import type { ComputedRef } from "vue";

import { createInjectionState } from "@vueuse/core";
import { toCamel } from "ts-case-convert";

type ContentParams = Record<string, number | string | undefined>;

function interpolate(content: string, params: ContentParams): string {
  return content.replace(/\{([a-z_]+)}/g, (match, key: string) => {
    const value = params[key] ?? params[toCamel(key)];
    return value !== undefined ? String(value) : match;
  });
}

const [provideContentParams, injectContentInterpolator] = createInjectionState(
  (params: ComputedRef<ContentParams>) => (content: string) =>
    interpolate(content, params.value),
  { defaultValue: (content: string) => content },
);

export { injectContentInterpolator, interpolate, provideContentParams };
